// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 20px;
  border-radius: 8px;
  color: white;
  font-weight: bold;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  animation: fade-in-out 3s ease-in-out forwards;
}

.toast-success {
  background-color: #4caf50;
}

.toast-error {
  background-color: #f44336;
}

.toast-warning {
  background-color: #ff9800; /* orange color */
}

@keyframes fade-in-out {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  10% {
    opacity: 1;
    transform: translateY(0);
  }
  90% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(20px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Toast/Toast.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,yCAAA;EACA,8CAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AACA;EACE,yBAAA,EAAA,iBAAA;AAEF;;AAEA;EACE;IAAK,UAAA;IAAY,2BAAA;EAGjB;EAFA;IAAM,UAAA;IAAY,wBAAA;EAMlB;EALA;IAAM,UAAA;IAAY,wBAAA;EASlB;EARA;IAAO,UAAA;IAAY,2BAAA;EAYnB;AACF","sourcesContent":[".toast {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  padding: 12px 20px;\n  border-radius: 8px;\n  color: white;\n  font-weight: bold;\n  z-index: 9999;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  animation: fade-in-out 3s ease-in-out forwards;\n}\n\n.toast-success {\n  background-color: #4caf50;\n}\n\n.toast-error {\n  background-color: #f44336;\n}\n.toast-warning {\n  background-color: #ff9800; /* orange color */\n}\n\n\n@keyframes fade-in-out {\n  0% { opacity: 0; transform: translateY(20px); }\n  10% { opacity: 1; transform: translateY(0); }\n  90% { opacity: 1; transform: translateY(0); }\n  100% { opacity: 0; transform: translateY(20px); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
